'use strict';
(function () {
    angular.module('AngularAdmin').directive('validatedInput', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, modelCtrl) {

                modelCtrl.$parsers.push(function (inputValue) {
                    var DEFAULT_VALIDATION = '[^0-9.]';
                    var regexStr = attrs.customValidation || DEFAULT_VALIDATION;
                    var regex = RegExp(regexStr,'g');

                    var transformedInput = inputValue.replace(regex, '');

                    if (transformedInput != inputValue) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }

                    return transformedInput;
                });
            }
        };
    });
})();